/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LuckyDraw = function () {
    function LuckyDraw() {
        var _this = this;

        (0, _classCallCheck3["default"])(this, LuckyDraw);

        _scope.Feature.EventBus(this);

        _scope.Feature.Room(this);

        _scope.MsgBus.On('Room.Init.Over', function () {
            _this._sub();
        });

        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(LuckyDraw, [{
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this2 = this;

            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
                _scope.MsgBus.UnSubAll('LuckyDraw.Open');

                _scope.MsgBus.UnSub('Destroy', _this2.destroyKey);

                // remove nats listener
                _this2.unsubEvents();
            });
        }

        //获取抽奖信息

    }, {
        key: 'Get',
        value: function Get(cb) {
            var id = this.Room.GetId();
            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawInfo');
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.flag = data.flag;
                cbData.info = data.msg;
                cbData.data = data.data;
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.Post(url, {}, callback, {
                'Content-Type': 'application/json'
            });
        }

        //抽奖报名

    }, {
        key: 'SignUp',
        value: function SignUp(obj, cb) {
            var _self = this;
            var id = this.Room.GetId();
            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/setLuckyDrawSignUp');
            var param = {
                uname: obj.userName,
                phone_voucher: obj.voucher,
                custom_voucher: obj.custom_voucher,
                custom_field: obj.custom_field
            };
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.info = data.msg;
                cbData.flag = data.flag;
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));

                var tracker = _self.Room.tracker;
                if (tracker && 'function' === typeof tracker.triggerEvent && data.status === 'y') {
                    tracker.triggerEvent({
                        category: 'interact',
                        action: 'lucky_draw'
                    });

                    var phone = obj.voucher;
                    if (phone && /^[0-9-+]+$/.test(phone)) {
                        tracker.triggerEvent({
                            category: 'interact',
                            action: 'phone',
                            label: (0, _stringify2["default"])({ phone: phone, is_verified: false })
                        });
                    }
                }
            };
            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, {
                'Content-Type': 'application/json'
            });
        }

        //获取最近一次抽奖结果信息

    }, {
        key: 'Result',
        value: function Result(cb) {
            var _self = this;
            var id = this.Room.GetId();
            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawResult/v2');
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.flag = data.flag;
                cbData.info = data.msg;
                try {
                    // 格式化适配数据（兼容上个版本的数据结构）
                    var tempData = data.status === 'y' && data.data.length > 0 ? data.data[0] : {};
                    tempData.uptime_timestamp = tempData.uptime_timestamp || 0;
                    tempData.service_timestamp = tempData.service_timestamp || 0;
                    // 观看页提交地址按钮变成不可编辑状态的时间戳 30分钟
                    tempData.disable_edit_time = tempData.uptime_timestamp + (Math.round(Date.now() / 1000) - tempData.service_timestamp) + 1800;
                    // 奖品名称
                    tempData.remark = tempData.award_name;
                    delete tempData.award_name;
                    cbData.data = tempData;

                    // 根据中奖记录id获取抽奖结果中奖名单（这么麻烦都是为了兼容上个版本的数据结构）
                    _self._GetLuckyDrawLuckyInfo(cbData.data.ld_record_id, function (res) {
                        res = JSON.parse(res);
                        cbData.data.luckers = res.data || [];
                        cbData.data.luckers.map(function (item) {
                            item.voucher = item.phone_voucher;
                            item.remark = cbData.data.remark || '';
                            return item;
                        });
                        typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
                    });
                } catch (error) {
                    cbData.data = {};
                    typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
                }
            };
            Fetcher.Get(url, callback);
        }

        //获取历史中奖信息

    }, {
        key: 'GetAllResult',
        value: function GetAllResult(cb) {
            var _self = this;
            var id = this.Room.GetId();
            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawResult/v2');
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                try {
                    cbData.status = data.status;
                    cbData.flag = data.flag;
                    cbData.info = data.msg;
                    cbData.data = data.data || [];
                    // 客户端时间戳
                    var clientTime = Math.round(Date.now() / 1000);
                    // 中奖记录id集合 ‘,’ 隔开
                    var recordIds = '';
                    // 格式化适配数据（兼容上个版本的数据结构）
                    cbData.data.map(function (lottery) {
                        lottery.uptime = _self._formatTime(lottery.uptime_timestamp);
                        // 观看页提交地址按钮变成不可编辑状态的时间戳 30分钟
                        lottery.disable_edit_time = lottery.uptime_timestamp + (clientTime - lottery.service_timestamp) + 1800;
                        // 奖品名称
                        lottery.remark = lottery.award_name;
                        delete lottery.award_name;
                        // 默认的中奖名单
                        lottery.list = [];
                        // 收集中奖记录id集合
                        recordIds = recordIds + lottery.ld_record_id + ',';
                        return lottery;
                    });

                    // 根据中奖记录id集合获取所有抽奖结果对应的中奖名单
                    if (recordIds.length > 1) {
                        recordIds = recordIds.substring(0, recordIds.length - 1);
                        // 一次性发起收集所有中奖记录对应的中奖名单（这么麻烦都是为了兼容上个版本的数据结构）
                        _self._GetLuckyDrawLuckyInfoList(recordIds, function (res) {
                            res = JSON.parse(res);
                            cbData.data.map(function (lottery) {
                                // 数据结构：{'ld_record_id': '中奖名单'}
                                lottery.list = res.data && res.data[lottery.ld_record_id] || [];
                                lottery.list.map(function (item) {
                                    item.voucher = item.phone_voucher;
                                    return item;
                                });
                                return lottery;
                            });
                            typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
                        });
                    } else {
                        typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
                    }
                } catch (error) {
                    cbData.data = [];
                    typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
                }
            };
            Fetcher.Get(url, callback);
        }

        /**
         * 获取已填写的收货地址
         * @param {string} recordId 抽奖记录id
         * @param {function} cb 回调函数
         */

    }, {
        key: 'GetAddress',
        value: function GetAddress(recordId, cb) {
            var id = this.Room.GetId();
            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawAddress?ld_record_id=' + recordId);
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.flag = data.flag;
                cbData.info = data.msg;
                cbData.data = data.data;
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.Get(url, callback);
        }

        /**
         * 设置收货地址
         * @param {*} address 发送的提交地址
         * @param {string} recordId 抽奖记录id
         * @param {*} cb 回调函数
         */

    }, {
        key: 'SetAddress',
        value: function SetAddress(address, recordId, cb) {
            var id = this.Room.GetId();
            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/setLuckyDrawAddress');
            var param = {
                ld_record_id: recordId,
                address: address
            };
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.flag = data.flag;
                cbData.info = data.msg;
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, {
                'Content-Type': 'application/json'
            });
        }
    }, {
        key: '_sub',
        value: function _sub() {
            var _this3 = this;

            var actId = this.Room.GetId();

            // 监听事件
            this.unsubEvents = nats.on('lucky_draw_' + actId, function (data) {
                var jsonObj = JSON.parse(data);

                switch (jsonObj.type) {
                    case 'open_lucky_draw':
                        // 开奖
                        _this3.Result(function (data) {
                            _scope.MsgBus.Pub('LuckyDraw.Open', data);
                        });
                        break;
                    case 'lucky_draw_save':
                        // 保存抽奖（开启抽奖功能）
                        console.log('lucky draw change:', data);
                        _scope.MsgBus.Pub('LuckyDraw.ConfigChange', data);
                        break;
                    default:
                        console.log('有一个抽奖事件');
                }
            });
        }

        /**
         * 根据抽奖记录id获取抽奖结果中奖名单
         * @param {string} recordId 抽奖记录id
         * @param {function} cb 回调函数
         */

    }, {
        key: '_GetLuckyDrawLuckyInfo',
        value: function _GetLuckyDrawLuckyInfo(recordId, cb) {
            var id = this.Room.GetId();
            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawLuckyInfo?ld_record_id=' + recordId);
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.flag = data.flag;
                cbData.info = data.msg;
                cbData.data = data.data || [];
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.Get(url, callback);
        }

        /**
         * 根据中奖记录id集合获取所有抽奖结果对应的中奖名单
         * 后端专门提供的一个接口用来兼容之前的获取历史中奖信息接口
         * @param {string} recordIds 记录id集合 通过''拼接 不能包含空格
         * @param {function} cb 回调函数
         */

    }, {
        key: '_GetLuckyDrawLuckyInfoList',
        value: function _GetLuckyDrawLuckyInfoList(recordIds, cb) {
            var id = this.Room.GetId();
            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawLuckyInfoList?ld_record_ids=' + recordIds);
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.flag = data.flag;
                cbData.info = data.msg;
                cbData.data = data.data || {};
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.Get(url, callback);
        }

        // 将时间戳格式化成字符串

    }, {
        key: '_formatTime',
        value: function _formatTime(time) {
            var date = new Date(time * 1000);
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0');
            var day = date.getDate().toString().padStart(2, '0');
            var hour = date.getHours().toString().padStart(2, '0');
            var minute = date.getMinutes().toString().padStart(2, '0');
            var second = date.getSeconds().toString().padStart(2, '0');
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
        }
    }, {
        key: '_formatResult',
        value: function _formatResult(data) {
            var arr = [];
            var lastLuckyDrawItem = null;
            data.map(function (n) {
                if (!lastLuckyDrawItem || n.uptime !== lastLuckyDrawItem.uptime) {
                    lastLuckyDrawItem = {
                        remark: n.remark,
                        uptime: n.uptime,
                        list: [{
                            uname: n.uname,
                            voucher: n.phone_voucher,
                            custom_voucher: n.custom_voucher
                        }]
                    };
                    arr.push(lastLuckyDrawItem);
                } else {
                    lastLuckyDrawItem.list.push({
                        uname: n.uname,
                        voucher: n.phone_voucher,
                        custom_voucher: n.custom_voucher
                    });
                }
            });
            return arr;
        }
    }]);
    return LuckyDraw;
}();

module.exports = LuckyDraw;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/LuckyDraw.js
 ** module id = 168
 ** module chunks = 1
 **/